import styled from 'styled-components/macro'

export const Asterisk = styled.p`
  margin-top: -0.84em;
  font-style: italic;
  font-weight: 300;
  font-size: 0.75em;
`
